__turbopack_context__.v({
  "badge": "LiveThumbnailVideo-module__Tj12rq__badge",
  "video": "LiveThumbnailVideo-module__Tj12rq__video",
});
